import { useEffect, useState } from "react";
import { Save, Loader2, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import AutoForm from "./AutoForm";

export default function SectionEditor({ sectionKey, title, description }) {
  const [value, setValue] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/site").then((r) => setValue(r.data?.[sectionKey] ?? {}));
  }, [sectionKey]);

  const save = async () => {
    setBusy(true);
    try {
      await api.put(`/admin/site/${sectionKey}`, value);
      toast.success("সংরক্ষিত হয়েছে");
    } catch {
      toast.error("সংরক্ষণ ব্যর্থ");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-3xl">
      <div className="flex items-start justify-between gap-4 mb-6">
        <div>
          <h1 className="font-heading text-2xl font-bold text-stone-800">{title}</h1>
          {description && <p className="text-sm text-stone-500 mt-1">{description}</p>}
        </div>
        <div className="flex items-center gap-2">
          <a href="/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-full border border-stone-200 px-4 py-2 text-sm text-stone-600 hover:bg-stone-50">
            <ExternalLink className="h-4 w-4" /> লাইভ দেখুন
          </a>
          <button onClick={save} disabled={busy || !value} data-testid={`save-${sectionKey}`} className="inline-flex items-center gap-2 rounded-full bg-[var(--c-primary)] text-white px-5 py-2 text-sm font-medium hover:bg-[var(--c-secondary)] transition-colors disabled:opacity-60">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} সংরক্ষণ
          </button>
        </div>
      </div>
      {value == null ? (
        <div className="text-stone-400 flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> লোড হচ্ছে...</div>
      ) : (
        <div className="bg-white rounded-2xl border border-stone-200 p-6">
          {Array.isArray(value) ? (
            <AutoForm value={{ items: value }} onChange={(nv) => setValue(nv.items)} />
          ) : (
            <AutoForm value={value} onChange={setValue} />
          )}
        </div>
      )}
    </div>
  );
}
